<template>
  <div>
          <v-container px-0 pb-0>
            <v-layout row justify-space-between>
              <v-col>
                <v-card >
                  <Keys />
                </v-card>
              </v-col>
            </v-layout>
          </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Keys from "@/components/Keys";

export default {
  components: {
    Keys
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
  data: () => ({
    loading: false,
    settings: {},
  })
};
</script>

<style>
</style>